import React from 'react';

const Icon171OrientationReclining = props => (
  <svg
    focusable="false"
    viewBox="0 0 800 800"
    aria-hidden="true"
    role="presentation"
    {...props}
  >
    <rect
      x="312.55"
      y="291.63"
      width="216.75"
      height="216.75"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M321.55,239.38h198.75c4.97,0,9,4.03,9,9v43.25h-216.75v-43.25c0-4.97,4.03-9,9-9Z"
      fill="transparent"
      stroke="currentColor"
      strokeDasharray="15"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="6"
    />
    <path
      d="M321.55,508.37h198.75c4.97,0,9,4.03,9,9v43.25h-216.75v-43.25c0-4.97,4.03-9,9-9Z"
      transform="translate(841.85 1068.99) rotate(-180)"
      fill="transparent"
      stroke="currentColor"
      strokeDasharray="15"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="6"
    />
  </svg>
);

export default Icon171OrientationReclining;
